import React, { useState } from "react";
import {
  submitTransactionEditApproval,
  submitTransactionDeleteApproval,
} from "../../services/api";
import toast from "react-hot-toast";
import "./transactions.css";

export default function TransactionActionModal({ transaction, onClose, onSuccess }) {
  const [mode, setMode] = useState("EDIT");
  const [submitting, setSubmitting] = useState(false);

  const [form, setForm] = useState({
    amount: transaction?.amount || "",
    contributionType: transaction?.contribution_type || "",
    channel: transaction?.channel || "CASH",
    referenceNo: transaction?.reference_no || "",
    cashierComment: "",
  });

  const setField = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const submit = async () => {
    // if (!form.cashierComment.trim()) {
    //   toast.error("Comment is required");
    //   return;
    // }

    try {
      setSubmitting(true);

      if (mode === "EDIT") {
        await submitTransactionEditApproval(transaction.transaction_id, {
          amount: form.amount,
          contributionType: form.contributionType,
          channel: form.channel,
          referenceNo: form.referenceNo,
          cashierComment: form.cashierComment,
        });

        toast.success("Edited transaction submitted for admin approval");
      }

      if (mode === "DELETE") {
        await submitTransactionDeleteApproval(transaction.transaction_id, {
          cashierComment: form.cashierComment,
        });

        toast.success("Transaction reversal request submitted for admin approval");
      }

      onSuccess?.();
      onClose?.();
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to submit approval");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal transaction-modal" style={{ maxWidth: 760 }}>
        <div className="modal-close" onClick={onClose}>✕</div>

        <div className="approval-header">

        <h2>
          Transaction Approval Request
        </h2>

        <span>
          Submit changes for Parokia Admin approval
        </span>

      </div>

        <div className="transaction-request-tabs">
          <button
            className={mode === "EDIT" ? "active" : ""}
            onClick={() => setMode("EDIT")}
          >
            Edit Transaction
          </button>

          <button
            className={mode === "DELETE" ? "active danger" : ""}
            onClick={() => setMode("DELETE")}
          >
            Request Reversal
          </button>
        </div>

 <div className="modal-section">

  <div className="transaction-summary-cards">

    <div className="summary-card">
      <span>Receipt No</span>

      <strong>
        {transaction?.transaction_code}
      </strong>
    </div>

    <div className="summary-card">
      <span>Member</span>

      <strong>
        {transaction?.full_name}
      </strong>
    </div>

    <div className="summary-card">
      <span>Amount</span>

      <strong>
        TSh {Number(transaction?.amount || 0).toLocaleString()}
      </strong>
    </div>

  </div>

</div>

        {mode === "EDIT" && (
          <div className="modal-section">
            <h4>Edit Transaction Details</h4>

            <div className="transaction-form-grid simple">
              <div>
                <label>Amount</label>
                <input
                  className="input"
                  type="number"
                  value={form.amount}
                  onChange={(e) => setField("amount", e.target.value)}
                />
              </div>

              <div>
                <label>Contribution Type</label>
                <input
                  className="input"
                  value={form.contributionType}
                  onChange={(e) => setField("contributionType", e.target.value)}
                />
              </div>

              <div>
                <label>Payment Type</label>
                <select
                  className="input"
                  value={form.channel}
                  onChange={(e) => setField("channel", e.target.value)}
                >
                  <option value="CASH">CASH</option>
                  <option value="BANK">BANK</option>
                </select>
              </div>

              <div>
                <label>Reference No</label>
                <input
                  className="input"
                  value={form.referenceNo}
                  onChange={(e) => setField("referenceNo", e.target.value)}
                />
              </div>
  
            </div>
            <div className="approval-preview-card">

  <h4>Change Preview</h4>

  <div className="preview-grid">

    <div className="preview-item">
      <label>Amount</label>

      <div className="preview-values">
        <span>
          {Number(transaction.amount || 0).toLocaleString()}
        </span>

        <span className="arrow">
          →
        </span>

        <strong>
          {Number(form.amount || 0).toLocaleString()}
        </strong>
      </div>
    </div>

    <div className="preview-item">
      <label>Contribution</label>

      <div className="preview-values">
        <span>
          {transaction.contribution_type}
        </span>

        <span className="arrow">
          →
        </span>

        <strong>
          {form.contributionType}
        </strong>
      </div>
    </div>

    <div className="preview-item">
      <label>Channel</label>

      <div className="preview-values">
        <span>
          {transaction.channel}
        </span>

        <span className="arrow">
          →
        </span>

        <strong>
          {form.channel}
        </strong>
      </div>
    </div>

    <div className="preview-item">
      <label>Reference</label>

      <div className="preview-values">
        <span>
          {transaction.reference_no || "-"}
        </span>

        <span className="arrow">
          →
        </span>

        <strong>
          {form.referenceNo || "-"}
        </strong>
      </div>
    </div>

  </div>

</div>
          </div>
        )}

     {mode === "DELETE" && (

  <div className="reversal-card">

    <div className="reversal-title">
      Transaction Reversal Request
    </div>

    <p>
      This request will be reviewed by the Parokia Administrator.
    </p>

    <div className="reversal-points">

      <div>
        ✓ Audit trail preserved
      </div>

      <div>
        ✓ Member notified
      </div>

      <div>
        ✓ Transaction marked reversed
      </div>

    </div>

  </div>

)}

        <div className="modal-section">
          <h4>Cashier Comment</h4>
          <textarea
            className="input"
            style={{ minHeight: 100 }}
            placeholder="Explain why this action is needed"
            value={form.cashierComment}
            onChange={(e) => setField("cashierComment", e.target.value)}
          />
        </div>

        <div className="modal-actions">
          <button className="btn light" onClick={onClose}>
            Cancel
          </button>

          <button
            className={mode === "DELETE" ? "btn danger" : "btn primary"}
            onClick={submit}
            disabled={submitting}
          >
            {submitting ? "Submitting..." : "Submit for Approval"}
          </button>
        </div>
      </div>
    </div>
  );
}